// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"103":"5eb4d277","728":"4afd0071"}[chunkId] + ".chunk.js";
};